import React from 'react'

const ImageTest: React.FC = () => {
  // Test data với hình ảnh
  const testQuestion = {
    id: "test-image-1",
    type: 'multiple_choice' as const,
    cau_hoi: "Câu hỏi test có hình ảnh minh họa",
    hinh_anh: "https://via.placeholder.com/400x300.png?text=Test+Question+Image",
    hinh_anh_giai_thich: "https://via.placeholder.com/400x200.png?text=Test+Solution+Image",
    lua_chon: ["Đáp án A", "Đáp án B", "Đáp án C", "Đáp án D"],
    dap_an_dung: 0,
    loi_giai: "Đây là lời giải test với hình ảnh minh họa",
    muc_do: 'M1' as const,
    diem: 1
  }

  console.log('🧪 Test question data:', testQuestion)
  console.log('🖼️ Question image:', testQuestion.hinh_anh)
  console.log('🖼️ Explanation image:', testQuestion.hinh_anh_giai_thich)

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow-lg">
      <h1 className="text-2xl font-bold mb-6 text-gray-900">🧪 Test Hiển thị Hình ảnh</h1>
      
      {/* Question Content */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          Câu 1: {testQuestion.cau_hoi}
        </h2>

        {/* Question Image Test */}
        <div className="mb-6">
          <h3 className="text-lg font-medium mb-2 text-gray-700">Hình ảnh câu hỏi:</h3>
          {testQuestion.hinh_anh ? (
            <div className="mb-4">
              <p className="text-sm text-green-600 mb-2">✅ Có hình ảnh: {testQuestion.hinh_anh}</p>
              <img
                src={testQuestion.hinh_anh}
                alt="Hình ảnh câu hỏi test"
                className="max-w-full h-auto rounded-xl shadow-md border border-gray-200"
                onLoad={() => console.log('✅ Question image loaded successfully')}
                onError={(e) => {
                  console.error('❌ Failed to load question image:', testQuestion.hinh_anh)
                  e.currentTarget.style.display = 'none'
                }}
              />
            </div>
          ) : (
            <p className="text-sm text-red-600">❌ Không có hình ảnh câu hỏi</p>
          )}
        </div>

        {/* Options */}
        <div className="space-y-3 mb-6">
          {testQuestion.lua_chon.map((option, index) => (
            <div key={index} className="p-3 border border-gray-200 rounded-lg">
              <span className="font-medium">{String.fromCharCode(65 + index)}. </span>
              {option}
            </div>
          ))}
        </div>

        {/* Solution with Image */}
        <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
          <h3 className="text-lg font-medium mb-2 text-blue-800">💡 Lời giải:</h3>
          <p className="text-blue-700 mb-3">{testQuestion.loi_giai}</p>
          
          {testQuestion.hinh_anh_giai_thich ? (
            <div>
              <p className="text-sm text-green-600 mb-2">✅ Có hình ảnh giải thích: {testQuestion.hinh_anh_giai_thich}</p>
              <img
                src={testQuestion.hinh_anh_giai_thich}
                alt="Hình ảnh giải thích test"
                className="max-w-full h-auto rounded-lg shadow-md border border-blue-300"
                onLoad={() => console.log('✅ Explanation image loaded successfully')}
                onError={(e) => {
                  console.error('❌ Failed to load explanation image:', testQuestion.hinh_anh_giai_thich)
                  e.currentTarget.style.display = 'none'
                }}
              />
            </div>
          ) : (
            <p className="text-sm text-red-600">❌ Không có hình ảnh giải thích</p>
          )}
        </div>
      </div>

      {/* Debug Info */}
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium mb-2 text-gray-800">🐛 Debug Info:</h3>
        <pre className="text-sm text-gray-600 overflow-auto">
          {JSON.stringify(testQuestion, null, 2)}
        </pre>
      </div>
    </div>
  )
}

export default ImageTest